const Answers = (props) => {
  return (
    <div className="Answers col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      {props.answers.length > 0 ? (
        <div className="Answers_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          {props.answers.map((option, option_index) => (
            <div
              forHtml={option.id}
              key={option.id || option_index}
              onClick={() => !props.lockMode && props.handleSelect(option.id)}
              className="answer_option col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            >
              <button className={`answer_text`}>
                <input
                  id={option.id}
                  type="checkbox"
                  checked={props.answer ? option.right_answer === props.answer : option.active ? true : false}
                />
                <span>{option.description}</span>
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div>
          <textarea
            className="examInput"
              rows={5}
              defaultValue={props.answer ? props.answer :""}
            placeholder="پاسخ خود را اینجا بنویسید"
            onChange={(e) => {
              props.handleTextAnw(e.target.value);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Answers;
